import router from '@/router'
import { AppHeader } from '@/components'
import { allowOnlyGuests } from '@/router/routerGuards'

export default () => {
  router.addRoute({
    path: '/api-onboarding/sign-up',
    name: 'api-sign-up',
    components: {
      default: () => import('./ApiSignUpLanding.vue'),
      header: AppHeader
    },
    beforeEnter: allowOnlyGuests()
  })

  router.addRoute({
    path: '/api-onboarding/sign-in',
    name: 'api-sign-in',
    components: {
      default: () => import('./ApiSignInLanding.vue'),
      header: AppHeader
    },
    beforeEnter: allowOnlyGuests()
  })

  router.addRoute({
    path: '/api-onboarding/accounting-connection',
    name: 'api-accounting-connection',
    components: {
      default: () => import('./ApiAccountingConnection.vue'),
      header: AppHeader
    },
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  })
}
